import { PRICE_LOCALE } from "@gameApp/helpers/price/consts";

const CURRENCIES_WITH_SYMBOL = ["USD", "EUR", "GBP", "CAD", "JPY", "RUB"];

/**
 * Returns currency symbol ($, £, €, ₽, etc.)
 * */
export function priceGetCurrencySymbol(currency: string): string {
  if (!currency) return currency;

  // если есть символ через toLocaleString или из юникода
  if (CURRENCIES_WITH_SYMBOL.includes(currency)) {
    switch (currency.toUpperCase()) {
      case "BTC":
        return "\u20BF";
      case "RUB":
        return "\u20BD";
      default:
        // создаем строку 0 с символом валюты, убираем 0 и пробелы, остается символ валюты
        return (0)
          .toLocaleString(PRICE_LOCALE, {
            style: "currency",
            currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })
          .replace("0", "")
          .trim();
    }
  }

  return "";
}
